<template>
  <div
    data-cy="skeleton-loader"
    class="skeleton-loading picture-skeleton"
    :style="{ width: itemWidth, paddingTop: itemHeight }"
  ></div>
</template>

<script>
export default {
  props: {
    itemWidth: {
      type: String,
      default: '100%',
    },
    itemHeight: {
      type: String,
      default: '100%',
    },
  },
};
</script>

<style lang="postcss" scoped>
.picture-skeleton {
  box-sizing: border-box;
}
</style>
